const SORT_SELECTOR = '.js-sort-select-field';
const ASC_ORDER = 'asc';
const DESC_ORDER = 'desc';
const CLEAR_PARAMS = ['page', 'sort', 'order'];
const sortElement = document.querySelector<HTMLSelectElement>(SORT_SELECTOR);

function getUrlWithSortParam(sort: string) {
  const url = new URL(window.location.href);
  for (const param of CLEAR_PARAMS) {
    url.searchParams.delete(param);
  }
  if (sort) {
    url.searchParams.set('sort', sort);
    url.searchParams.set('order', sort === 'rating' ? DESC_ORDER : ASC_ORDER);
  }
  return url.toString();
}

export function initSortSelectField() {
  if (!sortElement)
    return;
  sortElement.addEventListener('change', (event) => {
    const target = event.currentTarget as HTMLSelectElement;
    const value = target.value;
    window.location.href = getUrlWithSortParam(value);
  });
}
